import { useSelector } from 'react-redux'
import './HexItem.scss'

const HexItem = ({ svg }) => {
  const translation = useSelector((state) => state.translation)

  return <img src={svg} className="who-we-are-hex-item" alt={translation.project.name}></img>
}
export default HexItem
